import { ConversationList } from './ConversationList'
import { ConversationThreadPanel } from './ConversationThreadPanel'
import { CloseFullscreen } from '@mui/icons-material'
import { FC } from 'react'
import { GRAY_200, GRAY_800 } from 'constants/styling/theme'
import IconButton from '@mui/material/IconButton'
import { MOBILE_VIEW_WIDTH_QUERY } from 'constants/styling/theme'
import { ResponsiveDrawer } from 'components/common/ResponsiveDrawer'
import Stack from '@mui/material/Stack'
import { useChatWidget } from '../ChatWidget.context'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTranslation } from 'react-i18next'

/** Expanded chat experience: conversation list + thread panel inside a responsive drawer. */
export const ConversationsDrawer: FC = () => {
  const { t } = useTranslation(['chat'])
  const { mode, close, openReduced, selectedConversationId } = useChatWidget()
  const isMobile = useMediaQuery(MOBILE_VIEW_WIDTH_QUERY)

  return (
    <ResponsiveDrawer
      isOpen={mode === 'expanded'}
      onClose={close}
      title={t('chat:conversations_title')}
      width="92rem"
      headerActionsSlot={
        <IconButton
          aria-label={t('chat:actions.minimize')}
          onClick={openReduced}
          sx={{
            color: GRAY_800,
            backgroundColor: 'white',
            border: `1px solid ${GRAY_200}`,
            borderRadius: '50%',
            padding: '0.8rem',
          }}
        >
          <CloseFullscreen sx={{ fontSize: '2rem' }} />
        </IconButton>
      }
    >

      {isMobile
        ? (selectedConversationId ? <ConversationThreadPanel /> : <ConversationList />)
        : (
          <Stack direction="row" height="100%" minHeight="60vh">

            <Stack width="32rem" flexShrink={0} sx={{ borderRight: `1px solid ${GRAY_200}`, paddingRight: '1.2rem' }}>
              <ConversationList />
            </Stack>

            <Stack flex={1} minWidth={0}>
              <ConversationThreadPanel />
            </Stack>

          </Stack>
        )
      }

    </ResponsiveDrawer>
  )
}
